var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapsAlt = function SvgMapsAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#maps-alt_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.971,
    height: 18.144,
    x: 15.436,
    y: -7.519,
    fill: "#2F68D1",
    rx: 2,
    transform: "rotate(46.257 15.436 -7.519)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.971,
    height: 28.214,
    x: 44.561,
    y: -35.393,
    fill: "#2F68D1",
    rx: 2,
    transform: "rotate(46.257 44.56 -35.393)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.176,
    height: 33.604,
    x: 65.152,
    y: 21.649,
    fill: "#FFD2A8",
    rx: 2,
    transform: "rotate(46.257 65.152 21.649)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.974,
    height: 13.905,
    x: 38.363,
    y: 47.287,
    fill: "#B4CFFF",
    rx: 2,
    transform: "rotate(46.257 38.363 47.287)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.223,
    height: 13.905,
    x: 24.742,
    y: 33.056,
    fill: "#FF9D43",
    rx: 2,
    transform: "rotate(46.257 24.742 33.056)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.811,
    height: 31.833,
    x: 12.185,
    y: 45.074,
    fill: "#2F68D1",
    rx: 2,
    transform: "rotate(46.257 12.185 45.074)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.517,
    height: 30.653,
    x: 0.547,
    y: 7.775,
    fill: "#6C9BF1",
    rx: 2,
    transform: "rotate(46.257 .547 7.775)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "maps-alt_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    x: 5,
    y: 5,
    fill: "#fff",
    rx: 2
  })))));
};
export default SvgMapsAlt;